<template>
  <SkeletonPulse>
    <div class="rating-card-skeleton">
      <div class="rating-card-skeleton__aside">
        <SkeletonShape width="36px" height="20px" />
      </div>
      <div class="rating-card-skeleton__body">
        <div class="rating-card-skeleton__main">
          <div class="rating-card-skeleton__main-aside">
            <SkeletonShape width="50px" height="50px" border-radius="3px" />
          </div>
          <div class="rating-card-skeleton__content">
            <SkeletonShape width="283px" height="20px" />
            <SkeletonShape width="400px" height="15px" />
            <SkeletonShape width="194px" height="15px" />
          </div>
        </div>
        <div class="rating-card-skeleton__ratings">
          <div class="rating-card-skeleton__ratings-aside">
            <SkeletonShape width="45px" height="20px" />
          </div>
          <SkeletonShape width="250px" height="17px" />
        </div>
        <div class="rating-card-skeleton__review">
          <SkeletonShape width="260px" height="16px" />
          <SkeletonShape width="400px" height="15px" />
          <SkeletonShape width="194px" height="15px" />
          <SkeletonShape width="245px" height="15px" />
          <SkeletonShape width="130px" height="15px" />
          <SkeletonShape width="112px" height="15px" />
        </div>
      </div>
    </div>
  </SkeletonPulse>
</template>

<script>
  import SkeletonPulse from "src/components/SkeletonPulse/SkeletonPulse.vue";
  import SkeletonShape from "src/components/SkeletonShape/SkeletonShape.vue";
  
  export default {
    name: 'RatingCardSkeleton',
    components: { SkeletonPulse, SkeletonShape },
  }
</script>